import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ModalService } from '../modal/modal.service';
import { OrderService } from '@order/services/order.service';
import { StayOnPageModalComponent } from '@shared/components/stay-on-page-modal/stay-on-page-modal.component';

@Injectable({
  providedIn: 'root',
})
export class vsOrderGuard {
  subject = new Subject<boolean>();

  constructor(
    private modalController: ModalController,
    private modalService: ModalService,
    private translateService: TranslateService,
    private orderService: OrderService,
  ) {}

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): boolean | Observable<boolean | UrlTree> {
    let byPass = false;
    const targetUrl = currentState.url.slice(-5);

    this.orderService
      .getOrderHeader$()
      .pipe(take(1))
      .subscribe(orderHeaders => {
        if (
          orderHeaders?.orderType === 'VS' &&
          orderHeaders?.orderModifiable &&
          targetUrl === 'order'
        ) {
          console.log(
            'VS Order Type. Navigation away from order page is blocked.',
          );
          this.confirmDeactivate(nextState?.url.includes('touch'));
        } else {
          byPass = true;
        }
      });

    if (byPass) {
      return true;
    } else {
      return this.subject.asObservable();
    }
  }

  async confirmDeactivate(istouch: boolean) {
    if (!istouch) {
      window.history.pushState(
        null,
        '',
        this.createCurrentUrl(window.location.href, istouch),
      );
    }

    this.modalService.setModalOptions(
      istouch,
      StayOnPageModalComponent,
      {
        title: this.translateService.instant(
          'i18n.helpTooltips.touch.ordering.modal.title',
        ),
        buttonText: this.translateService.instant(
          'i18n.helpTooltips.touch.ordering.modal.button',
        ),
        exitButtonForTablet: true,
        exitButtonForMobile: true,
      },
      'simple-action-modal',
    );

    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );

    modal.onDidDismiss().then((resp: any) => {
      const confirmed = !!resp.data?.dispatchAction;
      this.subject.next(confirmed);
    });

    return await modal.present();
  }

  private createCurrentUrl(url: string, istouch: boolean): string {
    let returnUrl = url;
    let deviceType = istouch ? 'touch' : 'desktop';
    const lastIndex = url.lastIndexOf(deviceType);

    if (lastIndex > -1) {
      returnUrl =
        url.substring(0, lastIndex) + istouch
          ? '/desktop/order'
          : '/touch/order';
    }

    return returnUrl;
  }
}
